import React, { Component } from "react";
import SelectFieldImmediate from "../SelectFieldImmediate";
import agent from "../../../agent";
import { LOADER_TAG_ADMIN_FIELD_BMODEL } from "../../../constants";

export default class SelectBModel extends Component {
  onCreateOption = value => {
    return agent.AdminFields.create(
      { field: "bmodel", value },
      { loaderTag: LOADER_TAG_ADMIN_FIELD_BMODEL }
    );
  };

  render() {
    const { isCreateable = false } = this.props;

    return (
      <SelectFieldImmediate
        getFn={() =>
          agent.AdminFields.allOfType(
            { field: "bmodel" },
            { loaderTag: LOADER_TAG_ADMIN_FIELD_BMODEL }
          )
        }
        loaderTag={LOADER_TAG_ADMIN_FIELD_BMODEL}
        {...this.props}
        {...isCreateable && { onCreateOption: this.onCreateOption }}
      />
    );
  }
}
